import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { DropdownHelperModel } from 'src/app/admin-panel/models/helpers/dropdown-helper.model';
import { MemberCompanyModel } from 'src/app/admin-panel/models/members/member-company.model';
import { DetailsMemberCompanyComponent } from "./details-member-company/details-member-company.component";
import { ArchiveMemberCompanyComponent } from './archive-member-company/archive-member-company.component';
import { SearchMemberCompanyModel } from 'src/app/admin-panel/models/members/search-member-company,model';
import { MemberCompanyService } from 'src/app/admin-panel/services/members/member-companies.service';
import { Subject, takeUntil } from 'rxjs';
import { MessageService } from 'primeng/api';
import { CompanyStatusEnum } from 'src/app/admin-panel/enums/company-status.enum';

@Component({
  selector: 'app-member-companies',
  templateUrl: './member-companies.component.html',
  styleUrls: ['./member-companies.component.scss']
})
export class MemberCompaniesComponent implements OnInit {
  //#region Fields
  public imagePath: string = './assets/images/icons/company-img.png'
  public src_drop_opt: Array<DropdownHelperModel>;
  public src_drop_opt_1: DropdownHelperModel;
  public src_drop_opt_2: DropdownHelperModel;
  public selected_drop_opt: DropdownHelperModel;
  public totalRecords: number;
  public totalPages: number;
  public activeCompanies: number;
  public suspendedCompanies: number;
  public unsubscribe: Subject<void> = new Subject<void>();
  public companyList: Array<MemberCompanyModel>;
  public searchMemberCompanyModel: SearchMemberCompanyModel = new SearchMemberCompanyModel();
  public spinner: boolean = false
  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public memberCompanyService: MemberCompanyService,
    private messageService: MessageService
  ) {
    this.src_drop_opt = new Array<DropdownHelperModel>();
    this.src_drop_opt_1 = new DropdownHelperModel()
    this.src_drop_opt_1.id = '1';
    this.src_drop_opt_1.name = 'A_Z';
    this.src_drop_opt_2 = new DropdownHelperModel()
    this.src_drop_opt_2.id = '2';
    this.src_drop_opt_2.name = 'Z_A';
    this.src_drop_opt.push(this.src_drop_opt_1);
    this.src_drop_opt.push(this.src_drop_opt_2);


    this.companyList = new Array<MemberCompanyModel>();

  }

  ngOnInit(): void {
    this.getallmembercompanies(this.searchMemberCompanyModel)
  }
  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  //#endregion
  //#region Public Methods
  getallmembercompanies(searchModel: SearchMemberCompanyModel) {
    this.spinner = true;
    this.memberCompanyService.getallmembercompanies(searchModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.totalPages = response.totalPages;
          this.totalRecords = response.extendedData.totalActiveCompanies + response.extendedData.totalSuspendedCompanies;
          this.activeCompanies = response.extendedData.totalActiveCompanies;
          this.suspendedCompanies = response.extendedData.totalSuspendedCompanies;
          if (this.searchMemberCompanyModel.pageNumber > 1) {
            this.companyList = this.companyList.concat(response.data)
          }
          else {
            this.companyList = response.data;
          }
          this.spinner = false;         
        },
        error: errorResponse => {
          this.spinner = false;
        }
      });

  };
  loadMoreMemberCompanies() {
    this.searchMemberCompanyModel.pageNumber = this.searchMemberCompanyModel.pageNumber + 1;
    this.getallmembercompanies(this.searchMemberCompanyModel);
  }
  detailsCompany(id: string) {
    const ref = this.dialogService.open(DetailsMemberCompanyComponent, {
      data: {
        id: id
      },
      // header: 'Details Company',
      width: '450px',
      styleClass: 'ml_200, mb_15 , header_color'
    });
    ref.onClose.subscribe((item: any) => {

    });
  }
  suspendedCompany(id: string) {
    const ref = this.dialogService.open(ArchiveMemberCompanyComponent, {
      data: {
        id: id,
        active:true
      },
      header: 'Suspend Company',
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchMemberCompanyModel.pageNumber = 1;
        this.getallmembercompanies(this.searchMemberCompanyModel)
        this.messageService.add({severity:'success', summary:'Company was succesful suspended!',life:3000});
      }
    });
  }
  unsuspendedCompany(id: string) {
    const ref = this.dialogService.open(ArchiveMemberCompanyComponent, {
      data: {
        id: id,
        active:false
      },
      header: 'Unsuspend Company',
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchMemberCompanyModel.pageNumber = 1;
        this.getallmembercompanies(this.searchMemberCompanyModel)
        this.messageService.add({severity:'success', summary:'Company was succesful unsuspended!',life:3000});
      }
    });
  }
  changeTabView(event: any) {
    if (event.index == 2) {
      this.searchMemberCompanyModel.status=CompanyStatusEnum.Suspended;
      this.searchMemberCompanyModel.pageNumber=1;
    }
    if (event.index == 1) {
      this.searchMemberCompanyModel.status=CompanyStatusEnum.Active;
      this.searchMemberCompanyModel.pageNumber=1;
    }
    if (event.index == 0) {
      this.searchMemberCompanyModel.status=CompanyStatusEnum.All;
      this.searchMemberCompanyModel.pageNumber=1;
    }

    this.getallmembercompanies(this.searchMemberCompanyModel);
  }
  searchMemberCompanies(searchModel: SearchMemberCompanyModel) {
    searchModel.pageNumber = 1;
    this.getallmembercompanies(searchModel)
  }
  clearSearch() {
    this.searchMemberCompanyModel.city="";
    this.searchMemberCompanyModel.name="";
    this.getallmembercompanies(this.searchMemberCompanyModel)
  }
  //#endregion
  //#Private Methods
  //#endregion
}
